import * as React from 'react';
import { SimpleFormComponentProps, ApiToUse, SerializeType } from 'app/infrastructure/simple-form/types';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/field-types';
import { manageOptionsUnit, manageOptionsLocation } from 'app/area/shared/manage-options';
import { userOptions } from '../endpoints';
import { ids } from 'app/area/administration/constants';
import { AdministrationUserEditProps } from './types';
import { sfNames } from 'app/area/administration/edit/sf-names';
import { clearValidationFactory } from 'app/area/administration/shared/helpers';

import style from '../edit.scss';

export interface UnitLocationLangProps extends AdministrationUserEditProps {
  formComponent: React.ComponentType<SimpleFormComponentProps>;
}

export const UnitLocationLang = (props: UnitLocationLangProps) => {

  const { formComponent: SimpleForm, translation, data, editMode, clearValidation } = props;

  return <div className={style.section}>
    <div className="row expanders-in-equal-cols">
      <div id={ids.users.unit} className="col-lg-4 col-sm-12">
        <SimpleForm
          name={sfNames.unit}
          type={FIELD_TYPE.SELECT_SINGLE_HIERARCHY}
          descriptionAllLevels={true}
          optionsEndpoint={userOptions.unit}
          apiToUse={ApiToUse.ADMINAPI}
          placeholder={translation.search}
          translation={translation}
          label={{ text: translation.unit, required: false }}
          initialValue={data && data.unit}
          serialize={{ type: SerializeType.V_VALUE }}
          readOnly={!editMode}
          extraFooterButton={manageOptionsUnit(translation.manage_options)}
          clearServerValidation={clearValidationFactory(sfNames.unit, clearValidation)}
        />
      </div>

      <div id={ids.users.location} className="col-lg-4 col-sm-12">
        <SimpleForm
          name={sfNames.location}
          type={FIELD_TYPE.SELECT_SINGLE_HIERARCHY}
          descriptionAllLevels={true}
          optionsEndpoint={userOptions.location}
          apiToUse={ApiToUse.ADMINAPI}
          translation={translation}
          placeholder={translation.search}
          label={{ text: translation.location, required: false }}
          initialValue={data && data.location}
          serialize={{ type: SerializeType.V_VALUE }}
          readOnly={!editMode}
          extraFooterButton={manageOptionsLocation(translation.manage_options)}
          clearServerValidation={clearValidationFactory(sfNames.location, clearValidation)}
        />
      </div>

      <div id={ids.users.default_language} className="col-sm-12 col-lg-4">
        <SimpleForm
          name={sfNames.language}
          type={FIELD_TYPE.SELECT_SINGLE}
          optionsEndpoint={userOptions.language}
          placeholder={translation.search}
          apiToUse={ApiToUse.ADMINAPI}
          translation={translation}
          label={{ text: translation.language, required: editMode }}
          initialValue={data && data.language}
          serialize={{ type: SerializeType.V_VALUE }}
          readOnly={!editMode}
          clearServerValidation={clearValidationFactory(sfNames.language, clearValidation)}
        />
      </div>
    </div>
  </div>;
};
